var form = document.getElementsByTagName('form')[0];

function onSubmit (event) {
    event.preventDefault();
    let csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    fetch("/contacto", {
        headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken
        },
        method: "POST",
        credentials: "same-origin",
        body:JSON.stringify(Object.fromEntries(new FormData(form)))
    })
    .then(response => response.json())
    .then(data =>{
        if(data.hasOwnProperty('errors')){
            createMsgContainer("danger")
            printMsg(data.errors)
        }
        if(data.hasOwnProperty('success')){
            createMsgContainer("success")
            printMsg(data.success)
        }
    })
    .catch(error=> console.error('Hubo un problema con la petición:' + error.message))

}

function printMsg (msg) {
    $(".print-msg").find("ul").html('');
    $(".print-msg").css('display','block');
    $.each( msg, function( key, value ) {
        $(".print-msg").find("ul").append('<li>'+value+'</li>');
    });
}
function createMsgContainer(alertType){
    $(".print-msg").remove();
    $( "#form-title" ).after(
        `<div class="alert alert-${alertType} print-msg" role="alert" style="display:none">
            <ul></ul>
        </div>`
    );
}
form.addEventListener('submit', onSubmit);



// WEBPACK FOOTER //
// ./resources/welcome/bootstrap/assets/js/contact.js